import { castableAvatars, type FaceLockAvatar, type FaceLockCrew } from "@/lib/facelock";

// STILLS FIRST (server: shared/config/facelock-crew-speed.js, off by default).
// A new avatar's stills file trains first; once it is in, the avatar draws
// pictures (a corrido storyboard) while its video files still train. A video
// (a corrido's video, an ad) waits for those: the server refuses it with
// avatar_video_pending, before any charge. An older server sends none of
// these fields, so everything here reads as "not stills-ready".

/** Pictures work, its video files are still training. */
export const isStillsOnly = (a: FaceLockAvatar): boolean =>
  a.stills_ready === true && !a.castable && a.status !== "failed";

/**
 * What a corrido STORYBOARD may cast, newest first: every castable avatar and,
 * with stills first, the ones whose video files are still training. An ad is
 * video and keeps castableAvatars().
 */
export function boardAvatars(crew: FaceLockCrew | null): FaceLockAvatar[] {
  if (!crew) return [];
  // castableAvatars keeps its gates (enabled, picker or required) and its order;
  // the rows handed back are the real ones (a stills-only one stays castable:false).
  const byId = new Map(crew.avatars.map((a) => [a.id, a]));
  const widened = { ...crew, avatars: crew.avatars.map((a) => (isStillsOnly(a) ? { ...a, castable: true } : a)) };
  return castableAvatars(widened).map((a) => byId.get(a.id) || a);
}

/** Its video files' estimate in whole minutes (at least 1), or null when none is pending. */
export function videoEtaMinutes(a: FaceLockAvatar): number | null {
  if (!isStillsOnly(a) || typeof a.video_eta_s !== "number" || !(a.video_eta_s > 0)) return null;
  return Math.max(1, Math.round(a.video_eta_s / 60));
}
